var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center pt80 no-data"},[_c('img',{staticClass:"no-data-img",attrs:{"src":_vm.image || '/static/img/nullData.png'}}),_vm._v(" "),_c('p',{staticClass:"font-999 fs32"},[_vm._v(_vm._s(_vm.text || '暂无数据'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42bdc080","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NullData.vue
// module id = qVU3
// module chunks = 1